<template>
    <div :class="wrapClasses">
        <div class="flatpick-wrapper">
            <label v-if="label" :for="id">{{ label }}
                <template v-if="isRequired"><span class="asterisk">*</span></template>
            </label>
            <flat-pickr
                :disabled="disabled"
                :name="name"
                v-model="data"
                class="date-picker-input"
                :config="pickerOptions"
                :placeholder="placeholder"
                @on-close="triggerChange"
                ref="flatpickr"
            ></flat-pickr>
            <a href="javascript:" class="datepicker-clear-button">
                <ion-icon name="close-outline" v-if="clearButton" @click="clearValue"></ion-icon>
            </a>
        </div>
        <help-block :text="error"/>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            name: String,
            id: String,
            value: {
                required: true
            },
            placeholder: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            config: {
                required: false
            },
            clearButton: {
                default: false
            },
            fallbackValue: {
                default: ""
            },
            disabled: {
                default: false
            },
            isRequired: {
                type: Boolean,
                default: false
            }
        },
        data() {
            let self = this,
                defaults = {
                    mode: "single",
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'Y-m-d',
                    onReady(dates, value, instance) {
                        if (value !== '' && value !== null && value !== undefined && value !== 'null') {
                            instance.setDate(value)
                        }
                    },
                    onChange(str, value, instance) {
                        if (!value) {
                            instance.input.value = self.fallbackValue;
                        }
                    }
                },
                config = typeof this.config === 'object' ? this.config : {};

            config = Object.assign({}, defaults, config);

            this.triggerChange();

            return {
                pickerOptions: config,
                data: (this.value == null || this.value === 'null') ? '' : this.value
            }
        },
        computed: {
            wrapClasses() {
                return "form-group datepicker" + (this.error ? ' has-error' : '');
            },
        },
        components: {flatPickr},
        methods: {
            triggerChange() {
                setTimeout(() => {
                    if (this.pickerOptions.mode === 'range') {
                        if (typeof this.data === 'string') {
                            let values = this.data.split(' to ');

                            if (values.length < 2) {
                                this.$emit('input', this.data);
                            } else {
                                this.$emit('input', [values[0], values[1]]);
                            }
                        }
                    } else {
                        if (this.data === "") {
                            this.$emit('input', this.data);
                        } else {
                            this.$emit('input', this.data);
                        }
                    }
                });
            },
            clearValue() {
                this.data = 0;
                this.triggerChange();
            }
        }
    }
</script>

<style lang="scss">
    @import "resources/sass/_variables";

    .flatpick-wrapper {
        label {
            font-size: $primary-font-size;
            margin-bottom: 5px;
            color: $content-text-color;
        }

        input.date-picker-input {
            display: block;
            width: 100%;
            height: calc(1.6em + 0.75rem + 4px);
            padding: 0.375rem 0.75rem;
            font-size: $primary-font-size;
            font-weight: 400;
            line-height: 1.6;
            color: #495057;
            background-color: #f7f7f7;

            &:focus {
                border: none;
                outline: none;
                box-shadow: 0 0 5px 0 $primary-color;
            }
        }
    }
</style>
